export default __webpack_public_path__ + "static/media/Objeto.98382580.svg";